import edit from './edit'
import list from './list'

export default { list, edit, options: { label: 'Header' } }
